<template>
  <v-container fluid fill-height class="main-bg">
    <v-row class="text-center" justify="center" align-content="center">
      <v-col cols="12" md="4" justify="center">
        <v-card elevation="15">
          <v-card-text>
            <v-img
              :src="require('../assets/logo.svg')"
              class="my-3"
              contain
              height="160"
            />
            <p class="display-5 mb-5">
              <strong>あなたの素晴らしい１日を作ります</strong>
            </p>

            <v-form ref="test_form">
              <v-row>
                <v-col cols="11" class="mb-n3">
                  <v-combobox
                    label="組織キー"
                    v-model="organizationKey"
                    :items="organizationItems"
                    :hide-no-data="false"
                    outlined
                    dense
                  ></v-combobox>
                </v-col>
                <v-col cols="1" class="text-left pt-5 pr-6 ml-n3 mb-n3">
                  <v-tooltip right>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        @click="deleteOrgKeyTmp"
                        v-bind="attrs"
                        v-on="on"
                        tabindex="-1"
                      >
                        mdi-close
                      </v-icon>
                    </template>
                    <span>入力値を候補から消します</span>
                  </v-tooltip>
                </v-col>
              </v-row>
              <!--
              <FormInputComponent
                label="組織キー"
                v-model="organizationKey"
                rules="organizationKeyRules"
                :length="10"
              />
              -->
              <FormInputComponent
                label="ログイン名"
                v-model="loginId"
                rules="loginIdRules"
                :length="10"
                :counter="256"
                type="email"
              />

              <FormInputComponent
                label="パスワード"
                v-model="password"
                rules="passwordRules"
                :counter="8"
                type="password"
              />
            </v-form>
            <v-row class="pt-0 pb-3 pl-0 pr-0 mt-n6">
              <v-col>
                <v-checkbox
                  v-model="autoLogin"
                  label="次回から自動でログイン"
                  color="indigo"
                  hide-details
                ></v-checkbox>
              </v-col>
            </v-row>

            <Button @click="loginAuth" color="primary" :disabled="loading"
              >Login</Button
            >

            <Loader :loading="loading" />
          </v-card-text>
          <v-img
            :src="require('../assets/catch.svg')"
            class="catch"
            contain
            height="250"
          />
        </v-card>
        <p class="mt-10">Powered by</p>
        <v-img :src="require('../assets/logo.png')" contain height="65" />
      </v-col>
    </v-row>
    <div>
      <ConfirmDialog
        ref="confirm"
        title="パスワード変更"
        :message="confirmMessage"
        buttonMessage="OK"
        @confirm="showPasswordChange"
      >
      </ConfirmDialog>

      <DialogMessage ref="dialog" />
    </div>
  </v-container>
</template>
<script>
import axios from 'axios';
import config from '../const.js';
import message from '../message.js';
import moment from 'moment';
import {
  encrypt256,
  setSessionStorageItem,
  delSessionStorageItem,
  makeDateFormatStr,
  makeDateTimeStr,
  setLoginCookie,
  deleteLoginCookie,
} from '../common.js';
import ConfirmDialog from '@/components/Common/ConfirmMessage.vue';

export default {
  components: {
    ConfirmDialog,
  },
  data: () => ({
    valid: false,
    loading: false,
    data: {
      results: [],
    },
    // 組織名
    organizationKey: '',
    // ログイン名
    loginId: '',
    // パスワード
    password: '',
    // 自動ログイン
    autoLogin: false,
    // リダイレクトフラグ
    isRedirect: false,

    confirmMessage: null,

    organizationItems: [],
    organizationItemsName: 'organizationItems',
  }),

  created() {
    // セッションストレージ削除
    delSessionStorageItem();
    this.getCookieArray();
    // ローカルストレージから組織キーの配列を取得
    const serializedArray = localStorage.getItem(this.organizationItemsName);
    if (serializedArray != null) {
      const array = JSON.parse(serializedArray);
      // アルファベット順に並び替え
      array.sort((a, b) => a.localeCompare(b));
      this.organizationItems = array;
    }

    if (this.isRedirect) {
      // 次回からログインオンの場合はリダイレクト
      this.autoLogin = true;
      this.loginAuth();
    }
  },
  methods: {
    deleteOrgKeyTmp() {
      for (var i = 0; i < this.organizationItems.length; i++) {
        if (this.organizationItems[i] == this.organizationKey) {
          // 配列から削除する
          this.organizationItems.splice(i, 1);
          this.organizationKey = '';
          // ローカルストレージの設定
          const serializedArray = JSON.stringify(this.organizationItems);
          // 組織キー配列を削除
          localStorage.removeItem(this.organizationItemsName);
          // 組織キー配列を設定
          localStorage.setItem(this.organizationItemsName, serializedArray);
          break;
        }
      }
    },
    loginAuth: function () {
      if (!this.isRedirect) {
        //----- リダイレクトでない場合

        // 入力チェック
        if (!this.$refs.test_form.validate()) {
          // チェックエラー
          return;
        }

        // 組織キーチェック
        if (!this.organizationKey) {
          this.$refs.dialog.open(
            'info',
            '組織キーが入力されていません。組織キーは入力必須です。'
          );
          return;
        }

        // パスワードを暗号化
        this.password = encrypt256(this.password);
        if (this.autoLogin) {
          // 次回から自動ログインする場合、クッキーを登録
          setLoginCookie(this.organizationKey, this.loginId, this.password);
        } else {
          //クッキーを削除
          deleteLoginCookie();
        }
      }

      // ローディング画像表示
      this.loading = true;

      //----- ログイン認証リクエストPOST
      axios
        .post(config.CONNECT_URL + '/login', {
          ORGANIZATION_KEY: this.organizationKey, // 組織キー
          LOGIN_ID: this.loginId, // ログインID
          PASSWORD: this.password, // パスワード(暗号化)
        })
        .then((response) => {
          // Output
          this.results = response.data;
          if (this.results.length == 0) {
            // ユーザ情報取得不可
            let warnStr = message.MSG_WARN_LOGIN_ERROR;
            this.password = '';
            this.isRedirect = false;
            this.$refs.dialog.open('warning', warnStr);
          } else if (
            this.results[0].ORGANIZATION_EXPIRATION !=
              config.EXPIRATION_PURASUNOKI &&
            this.results[0].USER_RANK != config.USER_RANK_OWNER &&
            this.results[0].USER_RANK != config.USER_RANK_SYSOP &&
            this.results[0].USER_RANK != config.USER_RANK_TOP &&
            this.results[0].HAS_USER_GRADE == config.VALID_FLAG_OFF
          ) {
            // スタッフ等級設定不可
            let warnStr =
              '等級設定が行われていません。\n' +
              ' 管理者に等級設定を行って頂いた後、再度、ログインをお願いします。';
            this.$refs.dialog.open('warning', warnStr);
          } else {
            // sessionStorageにユーザ情報を保存
            var ret = setSessionStorageItem(
              this.results[0].USER_ID,
              this.results[0].SESSION_ID,
              this.password,
              this.organizationKey,
              this.results[0].ORGANIZATION_NAME,
              this.results[0].INITIAL_PASSWORD,
              this.results[0].COMMENT_MIN_STRING,
              this.results[0].USER_RANK_NAME_1,
              this.results[0].USER_RANK_NAME_2,
              this.results[0].USER_RANK_NAME_3,
              this.results[0].USER_RANK_NAME_4,
              this.results[0].USER_RANK_NAME_5,
              this.results[0].END_OPERATING_DATE,
              this.results[0].ORGANIZATION_EXPIRATION,
              this.results[0].USER_NAME,
              this.results[0].USER_NAME_FURIGANA,
              this.results[0].USER_RANK,
              this.results[0].POSITION_NAME,
              this.results[0].USER_AVATER,
              this.results[0].START_WORKING_AT,
              this.results[0].DEPARTMENT_KEY,
              this.results[0].DEPARTMENT_NAME
            );

            if (ret) {
              // ##### 組織キーを配列にローカルストレージに保存
              if (this.organizationItems.length > 0) {
                for (const value of this.organizationItems) {
                  if (value != this.organizationKey) {
                    // 配列の新しい組織キーを追加
                    this.organizationItems.push(this.organizationKey);
                    break;
                  }
                }
              } else {
                // 配列の新しい組織キーを追加
                this.organizationItems.push(this.organizationKey);
              }
              const serializedArray = JSON.stringify(this.organizationItems);
              // 組織キー配列を削除
              localStorage.removeItem(this.organizationItemsName);
              // 組織キー配列を設定
              localStorage.setItem(this.organizationItemsName, serializedArray);

              // ##### 代理ログイン ローカルストレージの値を初期化
              sessionStorage.removeItem(config.SESSION_PROXY_LOGIN_NAME);
              sessionStorage.setItem(
                config.SESSION_PROXY_LOGIN_NAME,
                config.PROXY_LOGIN_FALSE
              );

              // ##### sessionStorageへの保存成功
              if (this.password == this.results[0].INITIAL_PASSWORD) {
                if (this.results[0].EXPIRATION == 0) {
                  // 初回ログインの場合、プラスの氣画面に遷移
                  this.$router.push({ name: 'Top' });
                } else {
                  // 初回ログインでなく、且つ、初期パスワードの場合、確認ダイアログ表示
                  this.confirmMessage =
                    '初期パスワードでログインします。\n' +
                    ' パスワード変更画面でご自身のパスワードに変更してください。';
                  this.$refs.confirm.open();
                }
              } else if (this.results[0].USER_RANK == config.USER_RANK_OWNER) {
                // オーナー画面遷移処理
                this.$router.push({ name: 'OwnerTop' });
              } else {
                // 運用終了日チェック
                if (
                  this.results[0].END_OPERATING_DATE !=
                  config.END_OPERATING_DATE
                ) {
                  // 現在日時の取得
                  let dtNow = moment().format('YYYY-MM-DD');
                  // 運用終了日の取得
                  let strEndOperatingDate = makeDateFormatStr(
                    this.results[0].END_OPERATING_DATE,
                    '-',
                    '-',
                    ''
                  );
                  // 現在日付 >= 運用終了日の場合、ログアウト
                  if (
                    makeDateTimeStr('E', dtNow) >
                    makeDateTimeStr('S', strEndOperatingDate)
                  ) {
                    // 確認ダイアログ表示
                    this.$refs.dialog.open(
                      'warning',
                      message.MSG_WARN_LOGIN_CLOSING
                    );
                  } else {
                    // プラスの氣画面遷移処理
                    this.$router.push({ name: 'Top' });
                  }
                } else {
                  // プラスの氣画面遷移処理
                  this.$router.push({ name: 'Top' });
                }
              }
            } else {
              // ##### sessionStorageへの保存失敗
              // ログインエラー画面遷移
              this.$router.push({ name: 'LoginError' });
            }
          }
        })
        .catch((error) => {
          let errStr = '';
          // エラーメッセージ表示
          errStr = message.MSG_ERROR_SYTEM + error;
          this.$refs.dialog.open('error', errStr);
        })
        .finally(() => {
          // ローディング画像終了
          this.loading = false;
        });
    },
    showPasswordChange() {
      // 初期パスワードでログインした場合、強制的にパスワード変更画面に遷移
      this.$router.push({ name: 'UserSettings' });
    },
    getCookieArray() {
      let arr = new Array();
      if (document.cookie != '') {
        let tmp = document.cookie.split('; ');
        for (let i = 0; i < tmp.length; i++) {
          let data = tmp[i].split('=');
          arr[data[0]] = decodeURIComponent(data[1]);
        }
        if (arr['organizationKey'] && arr['loginId'] && arr['password'] != '') {
          this.organizationKey = arr['organizationKey'];
          this.loginId = arr['loginId'];
          this.password = arr['password'];
          this.isRedirect = true;
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.main-bg {
  background: url('~@/assets/main-bg.png');
  background-size: cover;
}
.v-card {
  position: relative;
}
.v-card:not(.v-sheet--tile):not(.v-card--shaped) {
  border-radius: 2em;
  border: 3px solid #555;
}
.catch {
  position: absolute;
  top: -25%;
  right: -50%;
}
@media screen and (max-width: 942px) {
  .catch {
    display: none;
  }
}
</style>
